<app-loader *ngIf="isLoadingDetails" [zIndex]="100" [fixedPosition]="true"></app-loader>
<h3 class="royal-blue-content-heading">Help us protect your account</h3>
<p class="mt-3 royal-blue-content-heading-subtext">We've sent a one time security code to your email. You'll usually get it within a few seconds but sometimes it can take up to a couple of minutes.</p>
<p class="mt-3 royal-blue-content-heading-subtext">Enter your security code below</p>
<form class="mt-5"
      [formGroup]="verifyDeviceForm"
      (ngSubmit)="verifyDevice()">
  <div class="mb-3">
      <label for="pin" class="form-label"><sup>* </sup>Security code</label>
      <input type="text"
             formControlName="pin"
             class="form-control form-control-lg"
             id="pin"
             placeholder="Security code from email"
             yp-e2e-id="security-pin">
      <div class="alert-container" *ngIf="(pin?.dirty || formSubmitted) && pin?.errors">
        <div class="alert alert-danger"
             yp-e2e-id="verify-password-validation-required"
             *ngIf="pin.errors?.required">{{FIELD_MANDATORY_ERROR}}
        </div>
      </div>

      <div class="alert-container" *ngIf="pinExpired">
        <div class="alert alert-danger">
          Your pin has expired we’ve sent you a new one
        </div>
      </div>

    <div class="alert-container" *ngIf="notValid">
      <div class="alert alert-danger">
        Your pin is invalid.
      </div>
    </div>

  </div>
  <div class="d-flex align-items-center justify-content-center mt-4">
    <button class="button button-sm button-primary w-100" yp-e2e-id="verify-device-button">Log into my account</button>
  </div>
</form>

